import axios from '@/utils/request'

export default {
	// 2021-09-23
	create(params) {
		return axios.post('/weddingDressHall/duty', params);
	},
	// 2021-09-23
	update(id, params) {
		return axios.put('/weddingDressHall/duty/' + id, params)
	}

}

